import React, {Component} from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import "./VerificationsPhoto.scss";
import {fetchVerificationMedias, resetVerificationMedias} from "../../../../creators/tagModeration.verification.medias";
import {LoadingBar} from "../../../components/Loader";
import history from "../../../../libs/history";
import _ from "lodash";
import createLink from "../../../../libs/createLink";
import {Link} from "react-router-dom";
//import Icon from "../../../components/Icon";
import {Button} from "../../../components/Button";
import ReactivityTagIa from "./ReactivityTagIa";
import {fetchCategoryRoot, resetCategoryRoot} from "../../../../creators/category.rootChildrens";
import {apiUrl} from "../../../../libs/api";
import moment from "moment-timezone";
import {toast} from "react-toastify";


class TagModerationVerificationPhotoIa extends Component {
    constructor(props) {
        super(props);
        this.classGender = [
            '',
            'gender-1',
            'gender-2',
            'gender-3',
            'gender-3',
            'gender-3',
            'gender-6',
        ];
        this.classBorderGender = [
            '',
            'gender-border-1',
            'gender-border-2',
            'gender-border-3',
            'gender-border-3',
            'gender-border-3',
            'gender-border-6',
        ];
        this.listGender = [
            '',
            'Homme',
            'Femme',
            'Couple',
            'Couple',
            'Couple',
            'Travesti',
        ];
        this.setTimeOut = null;
        this.state = {
            listDeclined : [],
            listUpdated : {},
            listCollection : [],
            isLoading : false
        }
        this.handleDeclined = this.handleDeclined.bind(this);
        this.handleCollection = this.handleCollection.bind(this);
        this.handleCategoryUpdated = this.handleCategoryUpdated.bind(this);
        this.reloadData = this.reloadData.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.props.fetchVerificationMedias({categoryId : this.props.currentCategory._id, more : false});
        if(this.props.isCategoryIa){
            this.props.fetchCategoryRoot(this.props.currentCategory.parents[0].slug, {sort : "order"});
        }

    }

    componentWillUnmount() {
        this.props.resetVerificationMedias();
        if(this.props.isCategoryIa) {
            this.props.resetCategoryRoot();
        }
        clearTimeout(this.setTimeOut);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.verificationMediasInitialized !== this.props.verificationMediasInitialized && this.props.verificationMediasInitialized && this.props.verificationMedias.length){
            let delai = moment(this.props.verificationMediasLockedUntil).diff(moment(), 'milliseconds');
            this.updateTimeOut(delai);
        }
    }

    updateTimeOut(delay = 0){
        clearTimeout(this.setTimeOut);
        if(delay > 0){
            this.setTimeOut = window.setTimeout(()=>{
                history.push(this.props.goBackUrl);
            }, delay);
        }
    }

    handleDeclined(id = null){
        if(id){
            id = id.toString();
            let listDeclined = this.state.listDeclined;
            let isDeclined = listDeclined.includes(id);
            if(isDeclined){
                listDeclined = listDeclined.filter(item => item !== id);
            }
            else{
                listDeclined.push(id);
            }
            this.setState({listDeclined});
        }
    }

    handleCollection(id = null){
        if(id){
            id = id.toString();
            let listCollection = this.state.listCollection;
            let isCollection = listCollection.includes(id);
            if(isCollection){
                listCollection = listCollection.filter(item => item !== id);
                toast("Ce média sera une \"Voissa Collection\"",{
                    className: 'toast-background toast-error',
                    bodyClassName: "toast-font toast-error",
                    progressClassName: 'toast-loader toast-error'
                });
            }
            else{
                listCollection.push(id);
                toast("Ce média ne sera plus une \"Voissa Collection\"",{
                    className: 'toast-background toast-success',
                    bodyClassName: "toast-font toast-success",
                    progressClassName: 'toast-loader toast-success'
                });
            }
            this.setState({listCollection});
        }
    }

    handleCategoryUpdated(id = null, knnId = null){
        if(id && knnId){
            let listUpdated = this.state.listUpdated;
            knnId = knnId.toString();
            id = id.toString();
            if(listUpdated[knnId]){
                 if(id === this.props.currentCategory._id.toString()) {
                     delete listUpdated[knnId];
                 }
                 else{
                     listUpdated[knnId] = id;
                 }
            }
            else{
                listUpdated[knnId] = id;
            }
            this.setState({listUpdated : listUpdated});
        }
    }

    reloadData(){
        clearTimeout(this.setTimeOut);
        this.setState({
            listDeclined : [],
            listUpdated : {},
            listCollection : [],
            isLoading : false
        });
        this.props.resetVerificationMedias();
        this.props.fetchVerificationMedias({categoryId : this.props.currentCategory._id, more : false});
    }

    handleSubmit(){
        if(this.props.isCategoryIa){
            this.setState({isLoading : true});
            let listUpdated = this.state.listUpdated;
            let arrayUpdated = Object.keys(listUpdated).map(key =>{
                return {
                    _id : key,
                    category : listUpdated[key]
                }
            });
            let arrayAccepted = this.props.verificationMedias.filter(item => !listUpdated[item._id.toString()]).map(item => item._id);

            apiUrl.patch(`/tag-moderations/verifications/update-ia`, {arrayAccepted, arrayUpdated, arrayCollection : this.state.listCollection, currentCategoryId : this.props.currentCategory._id}).then(response=>{
                this.reloadData();
            });
        }
        else{
            let arrayDeclined = this.state.listDeclined;
            let arrayAccepted = this.props.verificationMedias.filter(item => !arrayDeclined.includes(item._id.toString())).map(item => item._id);
            apiUrl.patch(`/tag-moderations/verifications/update-tag`, {arrayAccepted, arrayDeclined, arrayCollection : this.state.listCollection, currentCategoryId : this.props.currentCategory._id}).then(response=>{
                this.reloadData();
            });
        }
    }

    render() {
        return (
            <div id="tag-moderations-verification-photo">
                <style>
                    {`
                     header,#footer,.alert-bar{display: none !important;}
                    `}
                </style>
                {!this.props.verificationMediasInitialized ? (
                    <LoadingBar />
                ) : <div className={"toback"} onClick={()=> history.push(this.props.goBackUrl)}>Retour</div>}
                <div className={"title"}>Catégorie à vérifier {this.props.currentCategory.title}</div>
                {this.props.verificationMediasInitialized && this.props.verificationMediasTotal === 0 ? (
                    <span className={"text-danger"}>Aucun Media</span>
                ) : null}
                {this.props.verificationMediasInitialized && this.props.verificationMediasTotal > 0 ? (
                    <div className={"medias"}>
                        {this.props.verificationMedias.map(verification =>{
                            let media = verification.media;
                            let currentGender = _.get(media,'owner.profile.gender') || 0;
                            let isDeclined = this.state.listDeclined.includes(verification._id.toString());
                            return (
                                <div className={"media"} key={media._id}>
                                    <div className={"pseudo"}><Link className={"username"} to={createLink("userProfile", media.owner)} target={"_blank"} >{media.owner.username}</Link></div>
                                    <div className={`thumbnail ${this.classBorderGender[currentGender]}`}>
                                        <div className={`gender ${this.classGender[currentGender]}`}>Profil {this.listGender[currentGender]} </div>
                                        {media.slug ? <Link to={createLink("mediaviewerPhoto", {...media.owner, media})} target={"_blank"}><img alt={media.title} src={`${media.previewUrl}?height=350`} /></Link> : <img alt={media.title} src={`${media.previewUrl}?height=350`} />}
                                    </div>
                                    <div className={"categories"}>
                                        {this.props.isCategoryIa
                                            ? (<ReactivityTagIa
                                                categories={this.props.categories}
                                                categoriesInitialized={this.props.categoriesInitialized}
                                                categoriesLoading={this.props.categoriesLoading}
                                                knnId={verification._id}
                                                currentCategory={this.props.currentCategory}
                                                value={this.state.listUpdated[verification._id] || this.props.currentCategory._id}
                                                updateCategories={this.handleCategoryUpdated}
                                            />)
                                            : (<Button className={`btn-decline`}
                                                       active={isDeclined}
                                                       onClick={(e) => this.handleDeclined(verification._id)}
                                                       content={isDeclined ? "Annuler" : "Refuser"}/>
                                            )}
                                        {/*<div className={"bookmark-collection"}>
                                            {media.isCollection ? (
                                                <Icon type={"bookmark"} />
                                            ) : (
                                                this.state.listCollection.includes(verification._id.toString()) ? <Icon type={"bookmark-remove"} callback={()=>this.handleCollection(verification._id)} /> : <Icon type={"bookmark-add"} callback={()=>this.handleCollection(verification._id)} />
                                            )}

                                        </div>*/}
                                    </div>

                                </div>
                            )
                        })}
                    </div>
                ) : null}
                {this.props.verificationMediasInitialized && this.props.verificationMediasTotal > 0 ? (
                    <Button
                        className={"btn-next"}
                        active={!this.state.isLoading}
                        disabled={this.state.isLoading}
                        onClick={(e) => this.handleSubmit()}
                        content={"Continuer"}
                    />
                ) : null}
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        verificationMedias: state.verificationMedias.data,
        verificationMediasTotal : state.verificationMedias.total,
        verificationMediasInitialized : state.verificationMedias.initialized,
        verificationMediasLoading : state.verificationMedias.loading,
        verificationMediasLockedUntil : state.verificationMedias.lockedUntil || null,

        categories: (state.categoryRoot.data && state.categoryRoot.data.data) || [],
        categoriesInitialized : state.categoryRoot.initialized,
        categoriesLoading : state.categoryRoot.loading,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchVerificationMedias,
    resetVerificationMedias,
    fetchCategoryRoot,
    resetCategoryRoot
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(TagModerationVerificationPhotoIa);